import React from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useCustomizationStore } from "../store/useCustomizationStore";
import { useWebpageSectionChange } from "../store/useWebpageSectionChange";

export const CustomToggleLayout = (props) => {
  const { sectionKey, invertedMode = false } = props;

  const { handleSectionChange } = useWebpageSectionChange();

  const sectionConfig = useCustomizationStore((state) => state.sectionConfig);
  const sectionValue = sectionConfig[sectionKey]?.value;

  const handleChange = () => {
    const payload = {
      feature_key: sectionKey,
      feature_value: !sectionValue,
    };
    handleSectionChange({ payload });
  };

  return (
    <div>
      <SectionUnlockingSwitch
        value={invertedMode ? !sectionValue : sectionValue}
        onChange={handleChange}
      />
    </div>
  );
};
